// Custom hook for encryption/decryption with logging
import { useCallback, useMemo } from "react";
import { useLogs } from "../context/LogContext";
import CryptoJS from "crypto-js";

const PASSWORD = 'ByoSyncPayWithFace';
const SALT = 'ByoSync';

const key = CryptoJS.PBKDF2(PASSWORD, CryptoJS.enc.Utf8.parse(SALT), {
    keySize: 32 / 4,
    iterations: 65536,
    hasher: CryptoJS.algo.SHA256,
});

export function useEncryptDecrypt() {
    const { addLog } = useLogs();  // Use hook inside the custom hook
    // Turn off noisy crypto logs by default (they spam the UI and may leak sensitive data)
    const cryptoLogsEnabled = false;

    const encrypt = useCallback((text) => {
        if (cryptoLogsEnabled) addLog(`Encrypted the data ${text}`);

        const iv = CryptoJS.lib.WordArray.random(16);  // 16 bytes IV

        // Encrypt the text
        const encrypted = CryptoJS.AES.encrypt(text, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        if (cryptoLogsEnabled) {
            addLog(
                `Encrypted the data is ${
                    iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.ciphertext.toString(CryptoJS.enc.Base64)
                }`
            );
        }

        return iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }, [addLog, cryptoLogsEnabled]);

    const decrypt = useCallback((encryptedData) => {
        if (cryptoLogsEnabled) addLog(`Decrypted the encrypted data`);
        try {
            const [ivBase64, dataBase64] = encryptedData.split(":");
            const iv = CryptoJS.enc.Base64.parse(ivBase64);

            const decrypted = CryptoJS.AES.decrypt(
                { ciphertext: CryptoJS.enc.Base64.parse(dataBase64) },
                key,
                { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
            );

            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch (err) {
            console.error("Decryption error:", err);
            return null;
        }
    }, [addLog, cryptoLogsEnabled]);

    return useMemo(() => ({ encrypt, decrypt }), [encrypt, decrypt]);
}
